import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiGet, apiPost } from '../api/http';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // new state

  useEffect(() => {
    (async () => {
      try {
        const me = await apiGet('/api/auth/me');
        setUser(me);
      } catch {
        setUser(null);
      } finally {
        setLoading(false); // done checking
      }
    })();
  }, []);

  const login = async (email, password) => {
    const data = await apiPost('/api/auth/login', { email, password });
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await apiPost('/api/auth/logout');
    } catch {
      // ignore error, just clear session
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
